import React from 'react';
import styles from './DesktopPlaceholder.less';

export const DesktopPlaceholder = React.memo(() => (
  <div className={styles.desktopPlaceholder} data-placeholder="desktop" />
));
